/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2024-04-02 17:54:45
 */
/* eslint-disable */
import { loadScript } from '../../utils/utils'

// 声明全局变量类型
declare const TencentCaptcha: new (appId: string, callback: unknown, options: unknown) => unknown
declare const initSMCaptcha: (config: object, callback: (captcha: unknown) => void) => void
declare const __DEBUG__: boolean

declare global {
  interface Window {
    TencentCaptcha?: typeof TencentCaptcha
    initSMCaptcha?: typeof initSMCaptcha
  }
}

interface LoadTCaptchParams {
  options: object
  callback: (res: { ret: number; ticket?: string; randstr?: string; errorCode?: string; errorMessage?: string }) => void
}

export const loadTCaptch = ({ options, callback }: LoadTCaptchParams): Promise<unknown> => {
  return new Promise((resolve) => {
    let tCaptcha: unknown = null
    if (window.TencentCaptcha === undefined) {
      loadScript('/TCaptcha.js', () => {
        tCaptcha = new TencentCaptcha('196099232', callback, options)
        return resolve(tCaptcha)
      })
    } else {
      tCaptcha = new TencentCaptcha('196099232', callback, options)
      return resolve(tCaptcha)
    }
  })
}

export const loadSMCaptcha = (): Promise<unknown> => {
  return new Promise((resolve) => {
    const init = () => {
      initSMCaptcha(
        {
          organization: 'OcF3p8tNVcv28Hr1WOiY',
          product: 'popup',
          mode: 'slide',
          debug: __DEBUG__,
          maskBindClose: false,
          width: 300
        },
        function (SMCaptcha) {
          return resolve(SMCaptcha)
        }
      )
    }
    if (window.initSMCaptcha) {
      init()
    } else {
      loadScript(
        'https://castatic.fengkongcloud.cn/pr/v1.0.4/smcp.min.js',
        init
      )
    }
  })
}
